/**
 * LoadingSpinner — full-page or inline loading state.
 */
import { cn } from "@/lib/utils";
import { Spinner } from "@/components/ui/spinner";

interface LoadingSpinnerProps {
  /** Show as full-page centered, or inline. */
  fullPage?: boolean;
  /** Optional message. */
  message?: string;
  /** Size variant. */
  size?: "sm" | "md" | "lg";
  className?: string;
}

const sizeMap = {
  sm: "h-4 w-4",
  md: "h-5 w-5",
  lg: "h-8 w-8",
} as const;

export function LoadingSpinner({
  fullPage = false,
  message,
  size = "md",
  className,
}: LoadingSpinnerProps) {
  if (fullPage) {
    return (
      <div
        className={cn(
          "flex min-h-[60vh] flex-col items-center justify-center gap-3",
          className,
        )}
      >
        <Spinner className={cn(sizeMap[size], "text-primary")} />
        {message && (
          <p className="text-sm text-muted-foreground">{message}</p>
        )}
      </div>
    );
  }

  return (
    <div
      className={cn(
        "flex items-center justify-center gap-2 py-8",
        className,
      )}
    >
      <Spinner className={cn(sizeMap[size], "text-primary")} />
      {message && (
        <span className="text-sm text-muted-foreground">{message}</span>
      )}
    </div>
  );
}
